import React from 'react';

export default function AppBody({ mainClassNames, bodyClassNames, children }) {
  return (
    <div className={`app-body-main row bg-white p-4 shadow-sm ${mainClassNames}`}>
      <div className={`col-12 ${bodyClassNames}`}>{children}</div>
    </div>
  );
}
